export enum ActivationStepKey {
  LocationDetails = 'location-details',
  TransactionDetails = 'transaction-details',
  ProvidedServices = 'provided-services',
}

export type ActivationStepConfig = {
  key: ActivationStepKey;
  label: string;
  title: string;
  description?: string;
};

export const activationStepsConfig: ActivationStepConfig[] = [
  {
    key: ActivationStepKey.LocationDetails,
    label: 'Business details',
    title: 'Business details',
  },
  {
    key: ActivationStepKey.TransactionDetails,
    label: 'Transaction details',
    title: 'Business details',
  },
  {
    key: ActivationStepKey.ProvidedServices,
    label: 'Provided services',
    title: 'Business details',
  },
];

export const isActivationStepKey = (
  stepKey?: string
): stepKey is ActivationStepKey => {
  return Object.values(ActivationStepKey).includes(
    stepKey as ActivationStepKey
  );
};

export const getActivationStepTitle = (
  key: ActivationStepKey
): string | undefined => {
  return activationStepsConfig.find((step) => step.key === key)?.title;
};

export const getActivationStepDescription = (
  key: ActivationStepKey
): string | undefined => {
  return activationStepsConfig.find((step) => step.key === key)?.description;
};

export const getActivationStepIndex = (key: ActivationStepKey): number => {
  return activationStepsConfig.findIndex((step) => step.key === key);
};

export const getNextActivationStepKey = (
  key: ActivationStepKey
): ActivationStepKey | undefined => {
  const nextIndex = getActivationStepIndex(key) + 1;
  return activationStepsConfig[nextIndex]?.key;
};

export const getPreviousActivationStepKey = (
  key: ActivationStepKey
): ActivationStepKey | undefined => {
  const previousIndex = getActivationStepIndex(key) - 1;
  return activationStepsConfig[previousIndex]?.key;
};
